import React, { useState } from "react";
import { Button, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Linkify from "react-linkify";
import CustomFieldDescriptionModal from "go-app/components/CustomFields/CustomFieldDescriptionModal";
import { CustomFieldEntityApi, CustomFieldTemplateApi } from "go-segment/services/types";

interface Props {
	customFields: CustomFieldEntityApi[];
	customFieldsConfig: CustomFieldTemplateApi[];
}

const PartnerCustomFieldsCard = ({ customFields, customFieldsConfig }: Props) => {
	const { t } = useTranslation("admin");
	const [customFieldDescriptionToShowInModal, setCustomFieldDescriptionToShowInModal] = useState<
		CustomFieldTemplateApi | undefined
	>();
	const [showMore, setShowMore] = useState<boolean>(false);

	const parseCfSlugToName = (slug: string) => {
		if (slug) {
			const words = slug.split("_");
			words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1);
			return words.join(" ");
		}
		return "";
	};

	const handleOnClickCustomFieldName = (customField?: CustomFieldTemplateApi) => {
		if (!customField || !customField.description) return;

		setCustomFieldDescriptionToShowInModal(customField);
	};

	return (
		<>
			<Card>
				<Card.Body>
					<h5>{t("lib:go_component.custom_field.header.title")}</h5>
					{customFields
						.filter((_, i) => (showMore ? i >= 0 : i < 6))
						.map((cf, index) => {
							const customFieldConfig = customFieldsConfig.find(({ slug }) => slug === cf.slug);

							return (
								<div className="card-body-item" key={`cf-${index}`}>
									<div className="item-info" title={customFieldConfig?.description}>
										<span
											className="label"
											style={{ cursor: customFieldConfig?.description ? "pointer" : "unset" }}
											onClick={() => handleOnClickCustomFieldName(customFieldConfig)}
										>
											{parseCfSlugToName(cf.slug)}
										</span>
										<Linkify>{cf.value}</Linkify>
									</div>
								</div>
							);
						})}
					{customFields.length > 6 && (
						<Button variant="add" className="w-100" onClick={() => setShowMore(!showMore)}>
							{showMore ? t("lib:common.action.show_less") : t("common.action.show_more", { ns: "lib" })}
						</Button>
					)}
				</Card.Body>
			</Card>
			{customFieldDescriptionToShowInModal && (
				<CustomFieldDescriptionModal
					show={!!customFieldDescriptionToShowInModal}
					onHide={() => setCustomFieldDescriptionToShowInModal(undefined)}
					description={customFieldDescriptionToShowInModal.description || ""}
				/>
			)}
		</>
	);
};

export default PartnerCustomFieldsCard;
